/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

let $ = jQuery;
import template from "lodash/template";

let Cls = (window.OkCountdown = class OkCountdown {
	static initClass() {
		this.prototype.html = `\
<div class="okcountdown">
	<div class="flipper hours"></div>
	<div class="colon hourscolon">:</div>
	<div class="flipper minutes"></div>
	<div class="colon minutescolon">:</div>
	<div class="flipper seconds"></div>
</div>\
`;
	}

	constructor(params) {
		Object.keys(params).forEach((key) => {
			this[key] = params[key];
		});

		this.$container = $(this.container);
		if (!this.container || !this.$container.length) {
			return;
		}

		this.template = template(this.html);
		this.el = $(this.html);

		if (this.noflip) {
			this.el.addClass("noflip");
		} else {
			this.el.addClass("hasflip");
		}

		this.container.append(this.el);

		if (this.showhours) {
			this.el.addClass("showhours");
		}

		if (this.now && this.deadline) {
			this.setTimeLeft(this.deadline - this.now);

			this.updater = setInterval(() => {
				return this.update();
			}, 1000);
		}
	}

	setTimeLeft(timeleft) {
		let digitclass;
		this.timeleft = timeleft;

		let onehour = 60 * 60;
		this.hours = Math.floor(this.timeleft / onehour);
		this.minutes = Math.floor((this.timeleft - this.hours * onehour) / 60);
		this.seconds = this.timeleft % 60;

		if (
			this.noflip ||
			typeof FlipCounter === "undefined" ||
			FlipCounter === null
		) {
			digitclass = NormalCounter;
		} else {
			digitclass = FlipCounter;
		}

		// init the flippers
		this.hoursroller = new digitclass(
			this.el.find(".flipper.hours"),
			{
				number: this.hours,
				padZeroes: 2,
			},
		);

		this.minutesroller = new digitclass(
			this.el.find(".flipper.minutes"),
			{
				number: this.minutes,
				lowerBound: 0,
				lowerWrap: 59,
				padZeroes: 2,
			},
		);

		return this.secondsroller = new digitclass(
			this.el.find(".flipper.seconds"),
			{
				number: this.seconds,
				lowerBound: 0,
				lowerWrap: 59,
				padZeroes: 2,
			},
		);
	}

	update() {
		if (this.stopped) {
			return;
		}

		// If we're done, we're done
		if (this.timeleft === 0) {
			this.finish();
			return;
		}

		// otherwise, decrement by one second
		this.timeleft -= 1;
		this.seconds -= 1;
		this.secondsroller.decrement();

		// Roll over minute
		if (this.seconds === -1) {
			this.seconds = 59;
			this.minutes -= 1;
			this.minutesroller.decrement();

			// Roll over hour
			if (this.minutes === -1) {
				this.minutes = 59;
				this.hours -= 1;
				return this.hoursroller.decrement();
			}
		}
	}

	finish() {
		this.stop();
		if (this.onfinish && typeof this.onfinish === "function") {
			return this.onfinish();
		}
	}

	stop() {
		clearInterval(this.updater);
		return (this.stopped = true);
	}
});
Cls.initClass();

export default Cls;

// this is largely cribbed from FlipCounter, which is more elaborate
// FlipCounter should probably extend this, but that's beyond scope for now
window.NormalCounter = class NormalCounter {
	constructor(el, params) {
		this.el = el;
		if (params == null) {
			params = {};
		}
		this.number = params.number || 0;
		this.padZeroes = params.padZeroes ? parseInt(params.padZeroes, 10) : 0;

		// max
		this.lowerWrap = params.lowerWrap;

		// min
		this.lowerBound = params.lowerBound;

		this.setNumber();
	}

	setNumber() {
		let num = this.padNumber(this.number);
		return this.el.text(num);
	}

	padNumber(num) {
		num = String(num);
		let numLength = num.length;
		let zeroesToAdd = this.padZeroes - numLength;

		if (zeroesToAdd > 0) {
			for (
				let i = 0, end = zeroesToAdd, asc = 0 <= end;
				asc ? i < end : i > end;
				asc ? i++ : i--
			) {
				num = `0${num}`;
			}
		}

		return num;
	}

	increment() {
		this.number += 1;
		if (this.lowerWrap != null && this.number > this.lowerWrap) {
			this.number = 0;
		}
		return this.setNumber();
	}

	decrement() {
		this.number -= 1;
		if (this.lowerBound != null && this.number < this.lowerBound) {
			this.number = this.lowerWrap || 99;
		}
		return this.setNumber();
	}
};



// WEBPACK FOOTER //
// ./src/legacy/okcountdown.js